import { COUNTRIES } from '../../constants/constants';

export default function (country) {
	return COUNTRIES.find(c => c.value === country).display;
}
